import { type HeadlineMetrics, type LeadsData } from "../../api/generated";
import {
  createReportContext,
  type InferReport,
} from "../../context/ReportContext";

const leadsContext = createReportContext({ leadStatuses: "multi" })<
  { leadStatuses: string },
  {
    table: {
      leads: LeadsData["leads"];
      totalCount: number;
      redactedFields: string[];
    };
    stats: {
      headlineMetrics: HeadlineMetrics;
    };
    csv: void;
  },
  {
    startDate: string;
    endDate: string;
    selected: {
      leadStatuses: string[] | null;
    };
    search: string;
    page: number;
    pageSize: number;
    sortColumn: string | null;
    sortDesc: boolean | null;
  }
>();

export const {
  Provider: LeadsContextProvider,
  useReportContext: useLeadsContext,
} = leadsContext;

export type LeadsParams = InferReport<typeof leadsContext, "params">;
export type LeadsStates = InferReport<typeof leadsContext, "states">;
